/* ============================================================
   NYVRIX theme JS — Phase 1 foundation
   Dependency-free, defensive (never breaks Dawn).
   ============================================================ */
(function () {
  'use strict';

  /* ---------- analytics helper: dataLayer + Meta Pixel bridge ---------- */
  window.dataLayer = window.dataLayer || [];
  var PIXEL_MAP = {
    view_item: 'ViewContent',
    add_to_cart: 'AddToCart',
    add_to_wishlist: 'AddToWishlist',
    search: 'Search',
    begin_checkout: 'InitiateCheckout'
  };
  window.nyvTrack = function (name, props) {
    props = props || {};
    try { window.dataLayer.push(Object.assign({ event: name }, props)); } catch (e) {}
    try { if (window.fbq && PIXEL_MAP[name]) window.fbq('track', PIXEL_MAP[name], props); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name, props); } catch (e) {}
  };

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- mobile bottom-nav: search opens site search ---------- */
    var searchBtn = document.querySelector('[data-nyv-search]');
    if (searchBtn) {
      searchBtn.addEventListener('click', function (e) {
        // Persistent search bar first, then fall back to Dawn's header search modal
        var input =
          document.getElementById('nyv-search-input') ||
          document.querySelector('.nyv-search__input') ||
          document.querySelector('.search__input, input[type="search"]');
        if (input) {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
          // preventScroll stops the browser running its OWN scroll-into-view on
          // focus, which otherwise fights our scroll-to-top and lands the input
          // behind the sticky header (only its lower half shows). Our top:0 wins,
          // so the whole header group — search bar included — sits fully in view.
          setTimeout(function () {
            try { input.focus({ preventScroll: true }); }
            catch (err) { input.focus(); }
          }, 260);
          window.nyvTrack('search_open', {});
          return;
        }
        var toggler = document.querySelector('.header__search details summary');
        if (toggler) {
          e.preventDefault();
          toggler.click();
          setTimeout(function () {
            var i = document.querySelector('.search__input, input[type="search"]');
            if (i) i.focus();
          }, 120);
          window.nyvTrack('search_open', {});
        }
      });
    }

    /* ---------- mobile menu drawer (self-contained) ---------- */
    var menu = document.querySelector('[data-nyv-menu]');
    var menuOpenBtn = document.querySelector('[data-nyv-menu-open]');
    if (menu && menuOpenBtn) {
      var openMenu = function () {
        menu.hidden = false;
        requestAnimationFrame(function () { menu.classList.add('is-open'); });
        menuOpenBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        var f = menu.querySelector('[data-nyv-menu-close]');
        if (f) f.focus();
      };
      var closeMenu = function () {
        menu.classList.remove('is-open');
        menuOpenBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(function () { menu.hidden = true; }, 280);
        menuOpenBtn.focus();
      };
      menuOpenBtn.addEventListener('click', openMenu);
      menu.addEventListener('click', function (e) {
        if (e.target.closest('[data-nyv-menu-close]')) closeMenu();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
      });
    }

    /* ---------- product details: scroll-spy active tab ---------- */
    var pdpNav = document.getElementById('nyvPdpNav');
    if (pdpNav && 'IntersectionObserver' in window) {
      var links = Array.prototype.slice.call(pdpNav.querySelectorAll('a'));
      var secs = links
        .map(function (a) { return document.querySelector(a.getAttribute('href')); })
        .filter(Boolean);
      var spy = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          if (e.isIntersecting) {
            var id = '#' + e.target.id;
            links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === id); });
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      secs.forEach(function (s) { spy.observe(s); });
    }

    /* ---------- read-more clamp (collection descriptions, etc.) ---------- */
    document.querySelectorAll('[data-nyv-clamp]').forEach(function (el) {
      // only clamp if the content is actually tall
      if (el.scrollHeight <= 150) return;
      el.classList.add('nyv-clamp--collapsed');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nyv-readmore';
      btn.textContent = el.getAttribute('data-nyv-clamp') || 'Read more';
      btn.addEventListener('click', function () {
        el.classList.remove('nyv-clamp--collapsed');
        btn.remove();
      });
      el.insertAdjacentElement('afterend', btn);
    });

    /* ---------- persistent search bar shrink ----------
       Intentionally NOT handled here. The single scroll controller in
       sections/nyvrix-header.liquid toggles `.is-condensed` (top bar) and
       `.nyv-shrunk` (search bar) together in one frame, so the two never
       desync. A second listener here caused the search-bar glitch. */

    /* ---------- live cart badge sync ---------- */
    function refreshCartCount() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var badge = document.querySelector('[data-nyv-cart-count]');
          var cartLink = document.querySelector('.nyv-mnav__i[href*="/cart"]');
          if (!cartLink) return;
          if (cart.item_count > 0) {
            if (!badge) {
              badge = document.createElement('em');
              badge.className = 'nyv-mnav__badge';
              badge.setAttribute('data-nyv-cart-count', '');
              cartLink.appendChild(badge);
            }
            badge.textContent = cart.item_count;
          } else if (badge) {
            badge.remove();
          }
        })
        .catch(function () {});
    }
    // refresh after any add-to-cart interaction
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.action && e.target.action.indexOf('/cart/add') > -1) {
        setTimeout(refreshCartCount, 600);
      }
    });
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest && e.target.closest('[name="add"], .product-form__submit');
      if (addBtn) setTimeout(refreshCartCount, 700);
    });

    /* ---------- Liquid Glass (progressive enhancement, opt-in via [data-nyv-glass]) ---------- */
    // WebGL refraction is layered onto fixed functional elements that opt in.
    // Skipped on mobile / low-power / reduced-motion; CSS backdrop-filter is the fallback.
    var glassTargets = document.querySelectorAll('[data-nyv-glass]');
    var okGlass =
      glassTargets.length &&
      window.matchMedia('(min-width: 861px)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
      !window.matchMedia('(prefers-reduced-transparency: reduce)').matches;
    if (okGlass && typeof window.liquidGL === 'function') {
      try {
        window.liquidGL({
          target: '[data-nyv-glass]',
          snapshot: 'body',
          resolution: 1.6,
          refraction: 0.012,
          bevelDepth: 0.06,
          bevelWidth: 0.12,
          specular: true,
          shadow: true,
          reveal: 'fade'
        });
      } catch (e) { /* fall back to CSS glass silently */ }
    }
  });
})();
